import { useMemo } from 'react'

import { Product } from '@Generated/graphql'
import { getAvailableVariantsForProduct } from '@Globals/CMS/ProductHelpers'
import { useLocale } from '@Globals/Locale'

type VariantFilterOptions = {
  includeVariantsThatWillNeverRestock?: boolean
  product?: Product
}

export const useFilteredVariants = (
  {
    includeVariantsThatWillNeverRestock,
    product,
  }: VariantFilterOptions,
) => {
  const locale = useLocale()

  return useMemo(
    () => getAvailableVariantsForProduct({ includeVariantsThatWillNeverRestock, locale, product }),
    [includeVariantsThatWillNeverRestock, locale, product],
  )
}
